import { render, staticRenderFns } from "./dynamiList.vue?vue&type=template&id=1ed31f74&scoped=true"
import script from "./dynamiList.vue?vue&type=script&lang=js"
export * from "./dynamiList.vue?vue&type=script&lang=js"
import style0 from "./dynamiList.vue?vue&type=style&index=0&id=1ed31f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.106.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed31f74",
  null
  
)

export default component.exports